<script setup>
import { useModalStore } from "@/stores/ModalStore"
import { extractDate } from "@/utils/datetime"
import DatePicker from "@/components/DatePicker.vue"
import { useI18n } from "vue-i18n"
import { showErrorToast } from "@/utils/toast"

const modalStore = useModalStore()
const THIS_MODAL_NAME = 'editDate'

const { t } = useI18n()

const localDate = ref(null)
const initialDate = ref(null)
const localMinDate = ref(null)
const localTitle = ref('')
const localSubtitle = ref('')
const localEndpointURL = ref('')
const localId = ref(null)
const isSaving = ref(false)

const initializeLocalValues = () => {
  if (modalStore.modalParams.editDate?.date) {
    localDate.value = modalStore.modalParams.editDate.date
    initialDate.value = modalStore.modalParams.editDate.date
  } else {
    localDate.value = null
  }
  if (modalStore.modalParams.editDate?.minDate) {
    localMinDate.value = modalStore.modalParams.editDate.minDate
  } else {
    localMinDate.value = null
  }
  if (modalStore.modalParams.editDate?.title) {
    localTitle.value = modalStore.modalParams.editDate.title
  } else {
    localTitle.value = t('changeDate')
  }
  if (modalStore.modalParams.editDate?.subtitle) {
    localSubtitle.value = modalStore.modalParams.editDate.subtitle
  } else {
    localSubtitle.value = ''
  }
  if (!modalStore.modalParams.editDate?.endpointURL || modalStore.modalParams.editDate?.endpointURL === '') {
    modalStore.closeModal('editDate')
    showErrorToast('Niewłaściwy endpoint')
  } else {
    localEndpointURL.value = modalStore.modalParams.editDate.endpointURL
  }
  if (!modalStore.modalParams.editDate?.id || modalStore.modalParams.editDate?.id === '') {
    modalStore.closeModal('editDate')
    showErrorToast('Błędne ID')
  } else {
    localId.value = modalStore.modalParams.editDate.id
  }

}

const confirmDate = async () => {
  isSaving.value = true
  try {
    const response = await $backend(localEndpointURL.value, {
      body: {
        id: localId.value,
        value: extractDate(localDate.value, '-'),
      },
      method: 'POST',
    })

    if(response.success) {
      response.newDate = extractDate(localDate.value, '-')
      modalStore.closeModal(THIS_MODAL_NAME, response)
    }
  } catch (error) {
    //
  }
  isSaving.value = false

}

const closeModal = () => {
  localDate.value = null
  modalStore.closeModal('editDate')
}

onMounted(() => {
  initializeLocalValues()
})

onUnmounted(() => {
  localDate.value = null
})
</script>

<template>
  <VDialog
    v-model="modalStore.modals.editDate"
    max-width="350px"
  >
    <VCard>
      <VCardTitle>
        <div class="d-flex justify-space-between align-center pa-1">
          {{ localTitle }}
          <VIcon
            class="ml-auto"
            icon="ri-close-line"
            @click="closeModal"
          />
        </div>
      </VCardTitle>
      <VCardText class="pt-0">
        <VRow>
          <VCol
            v-if="localSubtitle.length"
            cols="12"
          >
            {{ localSubtitle }}
          </VCol>
          <VCol cols="12">
            <DatePicker
              v-model="localDate"
              :disabled="isSaving"
              class="mb-md-0 w-100"
              :inline="false"
              :set-icon="false"
              teleport
              :label-text="$t('date')"
              :min-date="localMinDate"
              style="min-inline-size: 125px;"
            />
          </VCol>
        </VRow>
      </VCardText>
      <VCardActions>
        <div class="d-flex pa-2 flex-fill justify-space-between">
          <VBtn
            variant="outlined"
            color="secondary"
            @click="closeModal"
          >
            {{ $t('cancel') }}
          </VBtn>
          <VBtn
            :disabled="extractDate(initialDate) === extractDate(localDate) || isSaving"
            :loading="isSaving"
            color="green"
            variant="flat"
            type="submit"
            @click="confirmDate"
          >
            {{ $t('confirm') }}
          </VBtn>
        </div>
      </VCardActions>
    </VCard>
  </VDialog>
</template>




